module.exports = {"id":"160310","name":"Jesús Gámez","rating":"72","photo":"./data/images/photos/0/160310.png","club":{"name":"Newcastle Utd","logo":"./data/images/clubs/NewcastleUtd.png"},"positions":["DD","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JesusGamez0.json
// module id = 2007
// module chunks = 0